import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface ValidateInviteResponse {
  creator_name: string;
}

export function useValidateInvite(token: string) {
  return useQuery({
    queryKey: queryKeys.invite.validate(token),
    queryFn: async () => {
      const response = await api
        .get(`invite/${token}`)
        .json<ValidateInviteResponse>();
      return response;
    },
    enabled: !!token,
    retry: false,
  });
}
